<template>
  <article class="search-result-part">
    <slo-product-image :source="image" class="rounded-sm" />
    <div>
      <h3>
        <a :href="item.url" @click="sendEvent('click', item, 'Global Search Part Result Clicked')">
          <span v-if="item.product_variation_part_number">
            <ais-highlight
              :hit="item"
              v-if="item.product_variation_part_number"
              attribute="product_variation_part_number"
              class="part-number"
            />
            /
          </span>
          <ais-highlight :hit="item" attribute="product_title" />
        </a>
      </h3>
      <p
        v-if="item.product_description || item.product_variation_description"
        class="text-sm c-gray-700"
      >
        <ais-highlight
          :hit="item"
          v-if="item.product_description"
          attribute="product_description"
        />
        <ais-highlight
          :hit="item"
          v-if="item.product_variation_description"
          attribute="product_variation_description"
        />
      </p>
    </div>
  </article>
</template>

<script>
import SloProductImage from '../../../lib/components/SloProductImage.vue';

export default {
  components: {
    SloProductImage
  },
  props: ['item', 'sendEvent'],
  computed: {
    image() {
      return this.item.variation_image || this.item.product_image || this.item.product_variation_image;
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-part {
  display: flex;

  .slo-product-image {
    width: 6.5rem;
    height: 6.5rem;
    margin-right: 1.25em;
    flex-shrink: 0;
  }
  .slo-product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .part-number {
    font-weight: $font-weight-bold;
  }
}
</style>
